import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE_CAMPAIGN = {
  'campaign': null,
  'loading': false,
  'successCreation': false,
  'attachments': [],
  'rawAttachments': [],
  'loadingAttachments': false,
};

export const campaign = (state, action) => {
  return createReducer(INITIAL_STATE_CAMPAIGN, {
    [ActionTypes.FETCHING_CAMPAIGN_BY_ID]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_CAMPAIGN_BY_ID]: (state, action) => ({
      ...state,
      'loading': false,
      'campaign': action.response.data,
    }),
    [ActionTypes.FETCHED_CAMPAIGN_BY_ID_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'campaign': null,
    }),
    [ActionTypes.ADDING_CAMPAIGN]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.ADDED_CAMPAIGN]: (state, action) => ({
      ...state,
      'loading': false,
      'successCreation': true,
      'campaign': action.response.data,
    }),
    [ActionTypes.ADDED_CAMPAIGN_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'successCreation': false,
      'campaign': null,
    }),
    [ActionTypes.CLEAR_CAMPAIGN]: (state, action) => ({
      ...state,
      ...INITIAL_STATE_CAMPAIGN,
    }),
    [ActionTypes.UPDATING_CAMPAIGN]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.UPDATED_CAMPAIGN]: (state, action) => ({
      ...state,
      'loading': false,
      'campaign': action.response.data,
    }),
    [ActionTypes.UPDATED_CAMPAIGN_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.SENDING_CAMPAIGN_NOTIFICATION]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.SENDED_CAMPAIGN_NOTIFICATION]: (state, action) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.SENDED_CAMPAIGN_NOTIFICATION_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.SET_CAMPAIGN_FILES]: (state, action) => ({
      ...state,
      'attachments': action.payload,
    }),
    [ActionTypes.FETCHING_CAMPAIGN_ATTACHMENTS]: (state, action) => ({
      ...state,
      'loadingAttachments': true,
    }),
    [ActionTypes.FETCHED_CAMPAIGN_ATTACHMENTS]: (state, action) => ({
      ...state,
      'attachments': [],
      'rawAttachments': action.response.data,
      'loadingAttachments': false,
    }),
    [ActionTypes.FETCHED_CAMPAIGN_ATTACHMENTS_FAILED]: (state, action) => ({
      ...state,
      'loadingAttachments': false,
      'attachments': [],
      'rawAttachments': [],
    }),
    [ActionTypes.SAVING_CAMPAIGN_ATTACHMENTS]: (state, action) => ({
      ...state,
      'loadingAttachments': true,
    }),
    [ActionTypes.SAVED_CAMPAIGN_ATTACHMENTS]: (state, action) => ({
      ...state,
      'loadingAttachments': false,
    }),
    [ActionTypes.SAVED_CAMPAIGN_ATTACHMENTS_FAILED]: (state, action) => ({
      ...state,
      'loadingAttachments': false,
    }),
  })(state, action);
};
